import type { StateCreator } from 'zustand';
import type { MonitoringSlices } from '.';

import { DomainTypes } from '@cobliteam/store';

interface TabsSliceState {
  selectedTab: DomainTypes;
  setSelectedTab: (selectedTab: DomainTypes) => void;
}

type StateCreatorGeofence = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], TabsSliceState>;

const createTabsSlice: StateCreatorGeofence = (set) => ({
  selectedTab: DomainTypes.VEHICLES,
  setSelectedTab: (selectedTab: DomainTypes) => set({ selectedTab }),
});

export type { TabsSliceState };
export default createTabsSlice;
